export default "__VITE_ASSET__fe15b629__"